import { Component } from "react";

export interface AlertProps {
    className?: string;
    type?: 'info' | 'danger' | 'warning' | 'success';
    children: React.ReactNode;
    // timeout?: number;
    // animate?: boolean;
    showCloseButton?: boolean;
    handleClose?: Function;
    size?: 'normal' | 'small';
}

class Alert extends Component<AlertProps, {}> {
    constructor(props: AlertProps) {
        super(props);

        this.handleClose = this.handleClose.bind(this);
    }

    handleClose(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();

        if (this.props.handleClose) {
            this.props.handleClose();
        }
    }

    render() {
        const {
            type = 'info',
            className: cssModifiers = '',
            showCloseButton = false,
            size = 'normal',
        } = this.props;

        const typeCss = type ? `alert-${type}` : '';

        return (
            <div
                className={`alert ${typeCss} ${cssModifiers} alert--${
                    size === 'small' ? 'sm' : 'md'
                }`}
                role="alert" 
            >
                {showCloseButton && (
                    <button
                        onClick={this.handleClose}
                        type="button"
                        className="close"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                )}
                {this.props.children}
            </div>
        );
    }
}

export default Alert;
